import { styled } from '../../../core/theme/styled';

export const StyledCenteredContainer = styled.div`
  text-align: center;
`;

export const StyledText = styled.div`
  padding: 0 ${(props) => props.theme.sizes.xlarge};
  margin-top: ${(props) => props.theme.sizes.normal};
  color: ${(props) => props.theme.configuration.primaryTextColor};
`;
